import { gql } from '@apollo/client'
import { DocumentNode } from 'graphql/language/ast'
import { STATUS_DELIVERED, STATUS_CANCELLED, STATUS_CHECKOUT } from '../types/Order'

export const GET_STATUS_TRANSLATE = gql`
  query StatusTranslate {
    ordersAggs(
      size: 0,
      query: {
        bool: {
          must: [{
            range: {
              created_at: {
                gte: "now-30d/d",
                lte: "now/d"
              }
            }
          }]
        }
      },
      aggs: {
        status: {
          terms: {
            field: "status_translate.keyword",
            size: 10,
            order: {
              _count: "desc"
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_STATUS_CANCELLED_DELIVERED_CHECKOUT_TRANSLATE = gql`
  query StatusTranslate {
    ordersAggs(
      size: 0,
      query: {
        bool: {
          must_not: [
            {
              terms: {
                cancellation_reason_translate_keyword: ["Suspeita de fraude"]
              }
            }
          ],
          must: [{
            range: {
              created_at: {
                gte: "now-30d/d",
                lte: "now/d"
              }
            }
          }, {
            terms: {
              status_translate_keyword: ["${STATUS_DELIVERED}", "${STATUS_CANCELLED}", "${STATUS_CHECKOUT}"]
            }
          }]
        }
      },
      aggs: {
        status: {
          terms: {
            field: "status_translate.keyword",
            order: {
              _count: "desc"
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_STATUS_CANCELLED_DELIVERED_TRANSLATE = gql`
  query StatusTranslate {
    ordersAggs(
      size: 0,
      query: {
        bool: {
          must_not: [
            {
              terms: {
                cancellation_reason_translate_keyword: ["Suspeita de fraude"]
              }
            }
          ],
          must: [{
            range: {
              created_at: {
                gte: "now-30d/d",
                lte: "now/d"
              }
            }
          }, {
            terms: {
              status_translate_keyword: ["${STATUS_DELIVERED}", "${STATUS_CANCELLED}"]
            }
          }]
        }
      },
      aggs: {
        status: {
          terms: {
            field: "status_translate.keyword",
            order: {
              _count: "desc"
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_PAYMENT_TYPES_TRANSLATE = gql`
  query PaymentTypes {
    ordersAggs(
      size: 0,
      query: {
        bool: {
          must: [{
            range: {
              created_at: {
                gte: "now-30d/d",
                lte: "now/d"
              }
            }
          }]
        }
      },
      aggs: {
        paymentTypes: {
          terms: {
            field: "payment_method_translate.keyword",
            size: 10,
            order: {
              _count: "desc"
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_CANCELLATION_REASON = gql`
  query CancellationReason {
    ordersAggs(
      size: 0,
      query: {
        bool: {
          must: [{
            range: {
              created_at: {
                gte: "now-30d/d",
                lte: "now/d"
              }
            }
          }]
        }
      },
      aggs: {
        paymentTypes: {
          terms: {
            field: "cancellation_reason_translate.keyword",
            size: 10,
            order: {
              _count: "desc"
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_CLIENTS = gql`
query Clients {
  ordersAggs(
    size: 0, 
    aggs: {
      clients: {
        terms: {
          field: "client_id"
        }
      }
    }
  ) {
    aggregations
  }
}
`

export const GET_STATES = gql`
query States {
  ordersAggs(
    size: 0,
    aggs: {
      states: {
        terms: {
          field: "state_name.keyword",
          size: 10000,
          order: {
            _term: "asc"
          }
        }
      }
    }
  ) {
    aggregations
  }
}
`

export const getCities = (states?: string[]): DocumentNode => {
  return gql`query Cities {
      ordersAggs(
        size: 0,
        query: {
          bool: {
            must: [{
              terms: {
                state_name_keyword: [${states ? '"' + states.join('","') + '"' : ''}]
              }
            }]
          }
        },
        aggs: {
          cities: {
            terms: {
              field: "city_name.keyword",
              size: 10000,
              order: {
                _term: "asc"
              }
            }
          }
        }
      ) {
        aggregations
      }
    }
    `
}

export const GET_PRODUCTS = gql`
query listSoldProducts {
  listSoldProducts {
    eanName
  }
}
`

export const GET_FACTORY_FILTER = gql`
query FactoryFilters($filters: NewOrderFilter) {
  newOrdersAggs(
    size: 0,
    filters: $filters,
    aggs: {
      factories: {
        terms: {
          field: "productFactory.keyword",
          size: 10000,
          order: {
            _key: "asc"
          }
        }
      }
    }
  )
  {
    aggregations
  }
}
`
